import React from "react";
import { Edit } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@mui/styles";

// CSS styling
const useStyles = makeStyles({
  icon: {
    padding: 0,
    marginRight: 8,
  },
});

// Renders the edit row button for tables
function EditButton({ onClick }) {
  const classes = useStyles();
  return (
    <IconButton
      className={classes.icon}
      color="primary"
      onClick={onClick}
      size="large"
    >
      <Edit />
    </IconButton>
  );
}

export default EditButton;
